export default __webpack_public_path__ + "static/media/transaction-error.d8be30ad.png";